export const AD_OPS_DASHBOARD_TAB_ORDER = [
  'campaign-reports',
  'ad-benchmarks',
  'sov-benchmarks',
  'bundle-generator',
  'current-campaigns',
] as const;

export type AdOpsDashboardTabKey = (typeof AD_OPS_DASHBOARD_TAB_ORDER)[number];

const TAB_LABELS: Record<AdOpsDashboardTabKey, string> = {
  'campaign-reports': 'Campaign Reports',
  'ad-benchmarks': 'Ad Benchmarks',
  'sov-benchmarks': 'SOV/Takeover Benchmarks',
  'bundle-generator': 'Bundle Generator',
  'current-campaigns': 'Current Campaigns',
};

/**
 * Tabs kept in the code but not shown. Bundle Generator is HIDDEN (Oct 2026):
 * the team doesn't use it right now. BundleGeneratorTab, the /api/ad-ops/bundles
 * routes and the adOps.bundles.manage permission are untouched; delete it from
 * this set to bring the tab back in its old slot.
 */
export const HIDDEN_AD_OPS_TABS: ReadonlySet<AdOpsDashboardTabKey> = new Set<AdOpsDashboardTabKey>(['bundle-generator']);

/**
 * Tabs gated on adOps.campaignReports.manage. Both benchmark tabs feed the
 * campaign report pages, so they share that permission. Current Campaigns needs
 * only adOps.view, which App.tsx already requires to open the dashboard.
 */
export function needsCampaignReports(tab: AdOpsDashboardTabKey): boolean {
  return tab === 'campaign-reports' || tab === 'ad-benchmarks' || tab === 'sov-benchmarks';
}

/** The tabs this user may open, in display order. */
export function adOpsDashboardTabs(canCampaignReports: boolean): { value: AdOpsDashboardTabKey; label: string }[] {
  return AD_OPS_DASHBOARD_TAB_ORDER.filter(
    (tab) => !HIDDEN_AD_OPS_TABS.has(tab) && (canCampaignReports || !needsCampaignReports(tab)),
  ).map(
    (tab) => ({ value: tab, label: TAB_LABELS[tab] }),
  );
}
